import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { CandidateDocument } from "@shared/modules/x-documents";
import { PageHeader } from "../../../core/components/ui/page-header";
import { Select } from "../../../core/components/ui/input";
import { Badge } from "../../../core/components/ui/badge";
import { expirations } from "../lib/api";

export function ExpirationsPage() {
  const [days, setDays] = useState(90);
  const [rows, setRows] = useState<(CandidateDocument & { reference: string | null })[]>([]);

  useEffect(() => {
    expirations(days).then(setRows).catch(() => setRows([]));
  }, [days]);

  const today = new Date().toISOString().slice(0, 10);

  return (
    <div className="page">
      <PageHeader
        title="Pièces qui expirent"
        subtitle="Passeports et permis à renouveler avant l'échéance."
        actions={
          <Select value={String(days)} onChange={(e) => setDays(Number(e.target.value))}>
            <option value="30">30 jours</option>
            <option value="90">90 jours</option>
            <option value="180">6 mois</option>
            <option value="365">12 mois</option>
          </Select>
        }
      />
      <table className="table">
        <thead>
          <tr>
            <th>Dossier</th>
            <th>Pièce</th>
            <th>Expire le</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((d) => (
            <tr key={d.id}>
              <td>{d.candidateId ? <Link to={`/candidats/${d.candidateId}/pieces`}>{d.reference ?? d.candidateId}</Link> : "—"}</td>
              <td>
                {d.originalName} <span className="muted">· {d.typeCode}</span>
              </td>
              <td>
                {d.expiresAt}{" "}
                {d.expiresAt && d.expiresAt < today ? <Badge variant="danger">expirée</Badge> : <Badge variant="warning">bientôt</Badge>}
              </td>
            </tr>
          ))}
          {rows.length === 0 ? (
            <tr>
              <td colSpan={3} className="table__empty">
                Rien n'expire dans ce délai.
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
}
